import Vue from 'vue';
import ButtonPill from '@/components/global/ButtonPill.vue';
import SvgIcon from '@/components/global/SvgIcon.vue';

Vue.component('SvgIcon', SvgIcon);
Vue.component('ButtonPill', ButtonPill);
